/**
 * Jira 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <JiraIcon className="w-8 h-8" />
 * <JiraIcon className="w-12 h-12" />
 * ```
 */
export function JiraIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Jira icon"
      role="img"
    >
      <title>Jira</title>
      <g id="Jira">
        <path
          id="Vector"
          d="M10.6829 22.0087H8.26338C4.61674 22.0087 2 19.7096 2 16.3428H15.0041C15.6787 16.3428 16.1147 16.8363 16.1147 17.5338V31C12.8636 31 10.6829 28.2904 10.6829 24.5131V22.0087ZM17.1054 15.3166H14.687C11.0392 15.3166 8.4225 13.059 8.4225 9.69214H21.4277C22.1012 9.69214 22.5775 10.143 22.5775 10.8417V24.3079C19.3265 24.3079 17.1064 21.5983 17.1064 17.821L17.1054 15.3166ZM23.5682 8.66595H21.1498C17.5021 8.66595 14.8853 6.36682 14.8853 3H27.8905C28.5641 3 29 3.49235 29 4.14956V17.6157C25.749 17.6157 23.5682 14.9061 23.5682 11.1288V8.66595Z"
          fill="#1868DB"
        />
      </g>
    </svg>
  );
}
